import React, { useEffect, useState } from 'react';
import { SiteNav } from './components/SiteNav';
import { Home } from './pages/Home';
import { Menu } from './pages/Menu';
import { WineExperience } from './components/wine/WineExperience';
import { PreorderSection } from './components/PreorderSection';
import type { ViewId } from './types/navigation';
export function App() {
  const [view, setView] = useState<ViewId>('hem');
  const [category, setCategory] = useState('mackor');
  const [pendingScroll, setPendingScroll] = useState<string | null>(null);
  const navigate = (next: ViewId) => {
    if (next === 'boka') {
      setView('vin');
      setPendingScroll('boka-bord');
      return;
    }
    setView(next);
    setPendingScroll(null);
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  };
  const openCategory = (id: string) => {
    setCategory(id);
    setView('meny');
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  };
  useEffect(() => {
    if (!pendingScroll) return;
    const element = document.getElementById(pendingScroll);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    setPendingScroll(null);
  }, [pendingScroll, view]);
  return <div className="min-h-screen w-full bg-cream text-ink selection:bg-ink/10 selection:text-ink overflow-x-hidden" data-id="element-0" data-mp="3rc9d24sih9w6">
      <SiteNav view={view} onNavigate={navigate} data-id="element-1" data-mp="6hr7hlrojf6" />

      <main data-id="element-2" data-mp="56l3b4umzkw">
        {view === 'hem' && <Home onNavigate={navigate} onOpenCategory={openCategory} data-id="element-3" data-mp="2zlle8zeb8glo" />}

        {view === 'meny' && <Menu activeCategory={category} onSelectCategory={setCategory} onNavigate={navigate} data-id="element-4" data-mp="33lwzoeehyky7" />}

        {view === 'vin' && <WineExperience data-id="element-5" data-mp="3dkus3sf1mymh" />}

        {view === 'forbestall' && <PreorderSection data-id="element-6" data-mp="3dmfqjt4hb1pm" />}
      </main>

      <footer className="px-6 py-12 border-t border-ink/10" data-id="element-7" data-mp="nvj35ett6cp7">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-8" data-mp="nv1284w7baay">
          <p className="font-sans text-[10px] tracking-[0.2em] uppercase text-ink/40" data-id="element-9" data-mp="sssrss9dikbz">
            Lilla Verket — Bageri · Café · Vin · Ost &amp; Chark
          </p>
          <a href="https://www.instagram.com/lilla.verket/" target="_blank" rel="noopener noreferrer" className="font-sans text-[10px] tracking-[0.15em] lowercase text-ink/40 hover:text-ink transition-colors duration-200" data-id="element-10" data-mp="3ubrg6gs32a2e">
            @lilla.verket
          </a>
        </div>
      </footer>
    </div>;
}